import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { CONFIG } from "../utility/constants/common-constants";

const axiosBaseQuery =
  ({ baseUrl }: { baseUrl: string }) =>
  async ({
    url,
    method,
    data,
    params,
    headers,
  }: {
    url: string;
    method: string;
    data?: any;
    params?: any;
    headers?: any;
  }) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as any;

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseUrl: CONFIG.baseURL || "",
  }),
  endpoints: () => ({}),
  tagTypes: [
    "MilestoneTask",
    "AdminList",
    "EducationLibrary",
    "MilestoneProgressBar",
    "PatientRedemptionOverview",
    "CarePlanDetails",
    "PatientLoginWorkflow",
    "PatientRedemptionDetails",
    "PatientList",
    "RewardWidget",
    "DashboardPreference",
    "LearningWidget",
    "RewardProgressWidget",
    "LearningLibraryContent",
    "VisualCelebration",
    "UserPreference",
    "NoShowAppointment",
  ],
});
